import jwtDecode from 'jwt-decode';
import { Loading } from 'element-ui';
import { createAction, createAsyncActionTypes } from 'vuex-module-generator';

import { fetchToken, refreshToken, revokeToken } from './api';
import tokenStorage from '../../helpers/tokenStorage';
import { logoutUser } from '../sso/helpers';
import { createMultipleMutations } from '../../helpers/store';

export const types = {
  GET_TOKEN: createAsyncActionTypes('Auth', 'GET_TOKEN'),
  REFRESH_TOKEN: createAsyncActionTypes('Auth', 'REFRESH_TOKEN'),
  DESTROY_TOKEN: createAsyncActionTypes('Auth', 'DESTROY_TOKEN')
};

export const AuthState = {
  isLoading: false,
  isUpdating: false,
  isAuthenticated: false,
  data: {},
  hasError: false
};

export const mutations = {
  ...createMultipleMutations(
    [types.GET_TOKEN.REQUEST, types.REFRESH_TOKEN.REQUEST],
    (state) => {
      state.isAuthenticated = false;
      state.isLoading = true;
      state.hasError = false;
    }
  ),

  ...createMultipleMutations(
    [types.GET_TOKEN.SUCCESS, types.REFRESH_TOKEN.SUCCESS],
    (state, payload) => {
      state.data = payload.data;
      state.isLoading = false;
      state.isAuthenticated = true;
      state.hasError = false;
    }
  ),
  [types.DESTROY_TOKEN.REQUEST](state) {
    state.isLoading = true;
    state.isUpdating = false;
  },

  [types.DESTROY_TOKEN.SUCCESS](state) {
    state.isLoading = false;
    state.isUpdating = false;
  },

  ...createMultipleMutations(
    [
      types.GET_TOKEN.FAILURE,
      types.DESTROY_TOKEN.FAILURE
    ],
    (state) => {
      state.isLoading = false;
      state.isAuthenticated = false;
      state.hasError = true;
    }
  ),
  [types.REFRESH_TOKEN.FAILURE](state) {
    state.isLoading = false;
    state.isAuthenticated = false;
    state.hasError = false;
  }
};

export default {
  state: AuthState,

  mutations,
  actions: {
    async fetchToken({ commit }, formData) {
      commit(createAction(types.GET_TOKEN.REQUEST));
      try {
        const { data: token } = await fetchToken(formData);
        const jwt = jwtDecode(token.access_token);
        tokenStorage.set(token);
        commit(createAction(types.GET_TOKEN.SUCCESS, { data: jwt }));

        return Promise.resolve(token);
      } catch (error) {
        commit(createAction(types.GET_TOKEN.FAILURE, { error }));

        return Promise.reject(error);
      }
    },
    async refreshToken({ commit }) {
      commit(createAction(types.REFRESH_TOKEN.REQUEST));
      try {
        const { data: token } = await refreshToken();
        const jwt = jwtDecode(token.access_token);
        tokenStorage.set(token);
        commit(types.REFRESH_TOKEN.SUCCESS, { data: jwt });

        return Promise.resolve(token);
      } catch (error) {
        commit(createAction(types.REFRESH_TOKEN.FAILURE, { error }));

        return Promise.reject(error);
      }
    },
    async destroyToken({ commit }) {
      const loading = Loading.service({
        lock: true,
        text: 'Session is being closed...'
      });
      commit(createAction(types.DESTROY_TOKEN.REQUEST));
      try {
        await revokeToken();
        commit(createAction(types.DESTROY_TOKEN.SUCCESS));
        loading.text = 'Session has been successfully closed';
        tokenStorage.clear();
        logoutUser(window.location.href);

        return Promise.resolve();
      } catch (error) {
        commit(createAction(types.DESTROY_TOKEN.FAILURE, { error }));
        loading.text = 'Session has been forcely closed';
        tokenStorage.clear();
        logoutUser(window.location.href);

        return Promise.reject(error);
      }
    }
  }
};
